$(window).on('load', function () {
    $(".navbar-toggler").click(function () {
        $("body").toggleClass("nav-active");
    });

    AOS.init();
    $('.counter-box').appear(function () {
        $('.count-text').each(function () {

            var $this = $(this),
                countTo = $this.attr('data-stop'),
                speed = $this.attr('data-speed');

            $({ countNum: 0 }).animate(
                { countNum: countTo },
                {
                    duration: parseInt(speed),
                    easing: 'swing',
                    step: function () {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $this.text(this.countNum);
                    }
                }
            );

        });
    }, { accY: -100 });
   
    var currentPath = window.location.pathname.split("/").pop();

    if (currentPath === "") {
        currentPath = "index.php";
    }

    $(".main-nav .nav li a").each(function () {
        var linkPath = $(this).attr("href").split("/").pop();

        if (linkPath === currentPath) {
            $(this).addClass("active");
        } else {
            $(this).removeClass("active");
        }
    });
});

jQuery(document).ready(function ($) {
    $(".menu-trigger").on("click", function () {
        debugger;
        console.log("menu clicked");
        $(".main-nav").toggleClass("menu-active");
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 200) {
            $('.navbar').addClass('fixed-header');
        }
        else {
            $('.navbar').removeClass('fixed-header');
        }
    });

    // Scroll up
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    });

    $('.scrollup').on("click", function () {
        $("html, body").animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});
